import React, {useContext} from "react";
import {StoreLocatorContext} from "../context/store-locator";
import {DealerSearchData} from "../lib/dealer-service";
import {__, getKm} from "../lib/utility";



interface SearchResultProps{
    dealers: DealerSearchData[] | null,
    selectDealer:Function

}


const SearchResult:React.FC<SearchResultProps> = (props) =>{
    if(props.dealers==null) return <></>;
    const dealers = props.dealers.map((dealer:DealerSearchData)=>{
        return (
            <div className={'dealer-card'} key={dealer.id}>
                <div className={'dealer-card-title'}>
                    <h3>{dealer.detail.company}</h3>
                </div>
                <div className={'dealer-location'}>
                    <div className={'distance'}>{getKm(dealer.distance)} km</div>
                    <div className={'place'}>{dealer.detail.city}</div>
                </div>
                <div className={'separator'}></div>
                <button
                    className={'dealer-action btn btn-outline'}
                    onClick={()=>props.selectDealer(dealer)}
                >{__('details')}
                </button>
            </div>
        )
    });

    return (
        <div className={'dealer-list'}>
            {dealers}
        </div>
    );
}
export default SearchResult;
